"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCaret = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var colors_1 = require("../../../theme/colors");
function IconCaret(props) {
    var direction = props.direction, isActive = props.isActive;
    var iconColor = colors_1.colors.steel[300];
    if (direction === 'descending' && isActive) {
        iconColor = colors_1.colors.steel[500];
    }
    if (direction === 'ascending' && isActive) {
        iconColor = colors_1.colors.steel[500];
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, direction === 'ascending' ? (react_1.default.createElement("svg", { width: "10", height: "15", viewBox: "0 0 10 15" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.1875H8.25L4.125 13L0 8.1875Z", fill: iconColor }))) : (react_1.default.createElement("svg", { width: "10", height: "15", viewBox: "0 0 10 1" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4.8125H8.25L4.125 0L0 4.8125Z", fill: iconColor })))));
}
exports.IconCaret = IconCaret;
//# sourceMappingURL=icons.js.map